import _ from 'lodash';

export function hasNoAvailibityForDate(date: Date, availability?: any) {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    if (date < today) {
        return true;
    } else if (!availability) {
        return false
    }

    return !availability[date.getTime()] || _.values(availability[date.getTime()]).every((val) => !val);
}
